import { HttpClient, HttpHeaders } from '@angular/common/http';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as api from './apihandler';
import { IdName } from '../models/standard.models';

export class PartnerApi {
  bearer = localStorage.getItem('bearer') as string;
  constructor(private http: HttpClient) { }

  getToPartners(): Observable<PartnerCompany[]> {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    return this.http.get<Array<PartnerCompany>>(api.jubloApi + 'api/Partner/GetPartnersToCompany', { headers })
  }

  getFromPartners(): Observable<PartnerCompany[]> {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    return this.http.get<Array<PartnerCompany>>(api.jubloApi + 'api/Partner/LookupCompanyPartners', { headers })
  }

  getPartners(): Observable<{ from: PartnerCompany[], to: PartnerCompany[] }> {
    const from$ = this.getFromPartners();
    const to$ = this.getToPartners();
    return forkJoin([from$, to$]).pipe(
      map(([from, to]) => {
        return { from, to }
      })
    );
  }

  getTradeGroups(): Observable<IdName[]> {
    return new Observable(obs => {
      const headers = new HttpHeaders({ 'Authorization': this.bearer });
      this.http.get<IdName[]>(api.jubloApi + 'api/Website/Offer/GetTradeGroups', { headers }).subscribe({
        next: (data: IdName[]) => {
          obs.next(data.sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1));
        },
        error: (err) => obs.error(err),
        complete: () => obs.complete()
      });
    })
  }

}

export class PartnerCompany {
  address: string;
  boardingStatus: string;
  city: string;
  companiesToPartnerId: string;
  companyId: string;
  companyName: string;
  companyNumber: number;
  connectionType: string;
  createdAt: string;
  customerId: string;
  logo: string;
  vat: string;
  zipCode: string;
  phone: string;
  email: string;
  website: string;
  partnerProperties: Array<PartnerProperties>;
  hasWiser: boolean = false;
  responsibles: Array<Responsible>;
  tradeGroup: IdName | null = null;
  from?: boolean;
  to?: boolean;
}

export class PartnerProperties {
  partnerPropertyId: string;
  partnerPropertyName: string;
}

export class Responsible {
  id: string;
  name: string;
  email: string;
}